import React, { useEffect } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import useFetch from '../../../../hooks/useFetch.js';
import { getV2TeamDetails } from '../../../../../api/index.js';
import { useParams } from 'react-router-dom';
import FormTeam from '../create/FormTeam.js';
import TeamDTO from '../../../../DTO/TeamDTO.js';

const EditTeam = () => {

    const { id } = useParams()

    const { data, isLoading, error, fetchData } = useFetch(getV2TeamDetails, [id]);

    useEffect(() => {
        if(!id)
            return

        fetchData()

    }, [id])

    useEffect(() => {

    }, [data])

    useEffect(() => {

        console.log("Error", error)

    }, [error])


    if(isLoading)
        return <CircularProgress/>
    
    if(!data)
        return <Typography sx={{m : 3}}>Aucune équipe trouvée</Typography>

    return <FormTeam team={new TeamDTO(data)} />

}

export default EditTeam